import { Directive, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";

import { DisplayIfDirective } from "directives/display-if.directive";
import { UserFacade } from "state/user.facade";

@Directive({
  selector: "[devUserOnly]",
  standalone: true,
})
export class DevUserOnlyDirective extends DisplayIfDirective {
  private readonly userFacade = inject(UserFacade);

  protected readonly displayCondition = toSignal<boolean>(
    this.userFacade.userHasDevPermissions$
  );
}
